const GAMEDAY_X = 'gameday-x';
const MICROPHONE = 'gameday-microphone';
const EXCLAMATION = 'exclaimation';
const SHOE = 'shoe';
const TRANSACTIONS = 'transactions';


const iconMap = {
  'CAUGHT_STEALING_2B': GAMEDAY_X,
  'CAUGHT_STEALING_3B': GAMEDAY_X,
  'CAUGHT_STEALING_HOME': GAMEDAY_X,
  'OTHER_OUT': GAMEDAY_X,
  'RUNNER_DOUBLE_PLAY': GAMEDAY_X,
  'CS_DOUBLE_PLAY': GAMEDAY_X,
  'PICKOFF_CAUGHT_STEALING_2B': GAMEDAY_X,
  'PICKOFF_CAUGHT_STEALING_3B': GAMEDAY_X,
  'PICKOFF_CAUGHT_STEALING_HOME': GAMEDAY_X,
  'PICKOFF_1B': GAMEDAY_X,
  'PICKOFF_2B': GAMEDAY_X,
  'PICKOFF_3B': GAMEDAY_X,

  'STOLEN_BASE_2B': SHOE,
  'STOLEN_BASE_3B': SHOE,
  'STOLEN_BASE_HOME': SHOE,
  'BALK': SHOE,
  'WILD_PITCH': SHOE,
  'PASSED_BALL': SHOE,
  'DEFENSEIVE_INDIFFERENCE': SHOE,
  'OTHER_ADVANCE': SHOE,
  
  'DEFENSIVE_SUBSTITUTION': TRANSACTIONS,
  'PITCHING_SUBSTITUTION': TRANSACTIONS,
  'OFFENSIVE_SUBSTITUTION': TRANSACTIONS,
  'DEFENSIVE_SWITCH': TRANSACTIONS,
  'OFFENSIVE_SWITCH': TRANSACTIONS,

  'GAME_ADVISORY': MICROPHONE,
  'EJECTION': MICROPHONE,
  'INJURY': MICROPHONE,
  'PICKOFF': MICROPHONE,
  'PICKOFF_ATTEMPT_HOME': MICROPHONE,
  'STEPOFF': MICROPHONE,

  'ERROR': EXCLAMATION,
  'PICKOFF_ERROR_1B': EXCLAMATION,
  'PICKOFF_ERROR_2B': EXCLAMATION,
  'PICKOFF_ERROR_3B': EXCLAMATION
};

const getSummaryPlayIconName = (type = '') => {
  return iconMap[type.toUpperCase()] || MICROPHONE;
};

export default getSummaryPlayIconName;
